import CertsRejectAction from './CertsRejectAction';

export default CertsRejectAction;
